import '../scss/style.scss';

import { headerFunc } from './common/_header';
import { commonFunc } from './common/_common';
import { homeFunc } from './pages/_home';
import { pagesFunc } from './pages/_pages';
import { omoiFunc } from './pages/_omoi';
import { ceremonyFunc } from './pages/_ceremony';
import { partyFunc } from './pages/_party';
import { aboutFunc } from './pages/_about';
import { photoFunc } from './pages/_photo';
import { cuisineFunc } from './pages/_cuisine';
import { itemFunc } from './pages/_item';
import { galleryFunc } from './pages/_gallery';
import { fairFunc } from './pages/_fair';
import { ajaxFunc } from './pages/_ajax';

window.addEventListener('DOMContentLoaded', function () {
  commonFunc();
  headerFunc();

  const TOP = document.querySelector('.p-home'); // TOPページ
  const OMOI = document.querySelector('.p-omoi'); // 私たちの結婚式への想い
  const CEREMONY = document.querySelector('.p-ceremony'); // 挙式スタイル
  const PARTY = document.querySelector('.p-party'); // パーティースタイル
  const ABOUT = document.querySelector('.p-about'); // JAMC八雲について
  const PHOTO = document.querySelector('.p-photo'); // フォトウェディング
  const CUISINE = document.querySelector('.p-cuisine'); // 料理
  const ITEM = document.querySelector('.p-item'); // ウェディングアイテム
  const GALLERY = document.querySelector('.p-gallery'); // ギャラリー
  const FAIR = document.querySelector('.p-fair'); // フェア

  if (TOP !== null) {
    homeFunc(); // TOPページ
  } else if (TOP === null) {
    pagesFunc(); // 下層ページ共通
  }

  if (OMOI !== null) {
    omoiFunc(); // 私たちの結婚式への想い
  }

  if (CEREMONY !== null) {
    ceremonyFunc(); // 挙式スタイル
  }

  if (PARTY !== null) {
    partyFunc(); // パーティースタイル
  }

  if (ABOUT !== null) {
    aboutFunc(); // 施設紹介
  }

  if (PHOTO !== null) {
    photoFunc(); // フォトウェディング
  }

  if (CUISINE !== null) {
    cuisineFunc(); // 料理
  }

  if (ITEM !== null) {
    itemFunc(); // ウェディングアイテム
  }

  if (GALLERY !== null) {
    galleryFunc(); // ギャラリー
  }

  if (FAIR !== null) {
    fairFunc(); // フェア
    ajaxFunc(); // 非同期でフェア情報を取得
    window.AJAX_FUNC = ajaxFunc;
  }
});
